
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateExternalTaskLinkDtoFormGroup() {
return new FormGroup({
    localTaskId: new FormControl<number | undefined>(undefined, [Validators.required]),
    externalTaskId: new FormControl<number | undefined>(undefined, [Validators.required]),
    projectLinkId: new FormControl<number | undefined>(undefined, [Validators.required]),
})
;
}
      